(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["MM-Klaviyo"] && !Shopify.designMode) return;
  try {
    
    (() => {
        const tagForms = (container) => {
            container.querySelectorAll('form').forEach((form) => {
                form.classList.toggle('mm-klaviyo-no-email', !form.querySelector('input[type="email"]'));
            });
        };

        const watchContainer = (container) => {
            if (container.dataset.mmKlaviyoWatched) return;
            container.dataset.mmKlaviyoWatched = 'true';
            tagForms(container);
            new MutationObserver(() => tagForms(container)).observe(container, { childList: true, subtree: true });
        };

        const init = () => document.querySelectorAll('.mm-klaviyo-form').forEach(watchContainer);

        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', init);
        } else {
            init();
        }
        document.addEventListener('shopify:section:load', init);
    })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["MM-Product-slider"] && !Shopify.designMode) return;
  try {
    
    function alignSliderRatings(slider) {
        const ratingDivs = [...slider.querySelectorAll('.mm-product-card-content-info-rating')];
        if (!ratingDivs.length) return;
        const hasRating = ratingDivs.some(div => div.querySelector('.mm-ratings-wrapper'));
        ratingDivs.forEach(div => {
            div.style.minHeight = hasRating ? '20px' : '';
            div.style.display = hasRating ? '' : 'none';
        });
    }

    document.addEventListener('DOMContentLoaded', () => {
        document.querySelectorAll('[data-section-id-product-slider]').forEach(slider => {
            alignSliderRatings(slider);
            /* Watch for dynamically loaded content (S&D recommendations via AJAX) */
            const observer = new MutationObserver(() => alignSliderRatings(slider));
            observer.observe(slider, { childList: true, subtree: true });
        });
    });

  } catch(e) { console.error(e); }
})();
})();
